<template>
	<dashboard-panel
		title="Preview"
		:edit-mode="editMode"
		@remove="$emit('remove')"
	>
		<div v-if="!restreamingData" class="p-3 text-muted text-center">
			No restreaming service configured.
		</div>
		<div v-else-if="restreamingData.status && restreamingData.status.status == 'live'" class="preview-fit">
			<div class="preview-video">
				<div style="position: relative; height: 100%">
					<div style="position: absolute; left: 0; top:0; right: 0; line-height: 1em; z-index: 1" class="p-1">
						<b-badge :variant="restreamingData.status.status == 'live' ? 'primary' : 'default'">{{restreamingData.status.status.toUpperCase()}}</b-badge>
						<b-badge variant="secondary" class="ml-1">{{restreamingData.status.uptime}}</b-badge>
					</div>
					<div v-if="videoLoading" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; text-align: center; z-index: 1; display: flex; align-items: center; justify-content: center">
						<b-icon icon="circle-fill" animation="throb"></b-icon>
					</div>
					<hls-player ref="player" :source="restreamingData.playbackUrlSecure||restreamingData.playbackUrl" @hlsManifestLoading="videoLoading=true" @hlsInitPtsFound="videoLoading=false" @muted="muted=true" @unmuted="muted=false" @pause="playing = false" @play="playing = true"></hls-player>
					<div style="position: absolute; bottom: 0; left: 0; right: 0; line-height: 1em; z-index: 1" class="p-1">
						<button type="button" class="btn btn-secondary btn-sm m-1" @click="$refs.player.togglePause()"><b-icon :icon="playing?'pause-fill':'play-fill'"/></button>
						<button type="button" class="btn btn-secondary btn-sm m-1" @click="$refs.player.toggleMute()"><b-icon :icon="muted?'volume-up-fill':'volume-mute-fill'"/></button>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="p-3">
			<b-input-group prepend="Restreaming service" label-for="restreaming-service-name" size="sm" class="mb-2">
				<b-form-input id="restreaming-service-name" size="sm" readonly :value="restreamingData.serviceName" />
			</b-input-group>
			<b-input-group prepend="SRT URL" label-for="srt-url" size="sm" class="mb-2">
				<b-form-input id="srt-url" placeholder="srt://" readonly :value="restreamingData.srtUrl" @focus="$event.target.select()"/>
				<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.srtUrl, 'Copied SRT URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
			</b-input-group>
			<b-input-group prepend="RTMP URL" label-for="rtmp-url" size="sm" class="mb-2">
				<b-form-input id="rtmp-url" placeholder="rtmp://" readonly :value="restreamingData.rtmpUrl" @focus="$event.target.select()"/>
				<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpUrl, 'Copied RTMP URL to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
			</b-input-group>
			<b-input-group prepend="Stream key" label-for="rtmp-key" size="sm" class="mb-2">
				<b-form-input id="rtmp-key" readonly :type="showRtmpKey?'text':'password'" :value="restreamingData.rtmpKey" @focus="$event.target.select()"/>
				<b-input-group-append><b-button variant="outline-info" @click="showRtmpKey=!showRtmpKey"><b-icon icon="eye"></b-icon></b-button></b-input-group-append>
				<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpKey, 'Copied stream key to clipboard', $event)"><b-icon icon="clipboard"/></b-button></b-input-group-append>
			</b-input-group>
			<div class="text-right">
				<b-button variant="warning" size="sm" @click="$emit('reset-stream')">Reset stream</b-button>
			</div>
		</div>
	</dashboard-panel>
</template>

<script>
import DashboardPanel from '../DashboardPanel.vue';
import HlsPlayer from '../HlsPlayer.vue';

export default {
	name: 'PreviewPanel',
	components: { DashboardPanel, HlsPlayer },
	props: {
		editMode: { type: Boolean, default: false },
		restreamingData: { type: Object, default: null },
	},
	data() { return {
		muted: true,
		playing: false,
		videoLoading: false,
		showRtmpKey: false,
	}},
	methods: {
		copyAndToast(string, message, event) {
			let target;
			if(event) {
				target = event.target;
				while(target && target.nodeName != 'DIV') target = target.parentNode;
			}
			this.$util.copyToClipboard(string, target);
			this.$bvToast.toast(message, { title: 'Success', variant: 'success', solid: true });
		},
	},
};
</script>

<style>
/* Fit the live video inside the panel while keeping 16:9 (letterbox/pillarbox as needed). */
.preview-fit {
	flex: 1 1 0;
	min-height: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #000;
	overflow: hidden;
}
.preview-video {
	position: relative;
	height: 100%;
	max-width: 100%;
	aspect-ratio: 16 / 9;
	line-height: 0;
}
.preview-video > div {
	width: 100%;
	height: 100%;
}
.preview-video video {
	position: absolute;
	top: 0;
	left: 0;
	width: 100% !important;
	height: 100% !important;
	max-width: none !important;
	max-height: none !important;
	object-fit: contain;
}
</style>
